import { useEffect, useState } from 'react'

import SubHeading from '../../../subHeading/SubHeading'

import './whydoit.css'

const collaboratorCards = [
  {
    title: 'Por qué hacerte Amiga colaboradora',
    items: [
      'Porque quieres implicarte activamente en el impulso de la cultura menstrual desde una perspectiva feminista, crítica, integral e inclusiva.',
      'Porque quieres formar parte de una red de mujeres, proyectos y entidades que generan conocimiento, investigación, divulgación y activismos.',
      'Porque valoras los espacios de intercambio, aprendizaje y colaboración entre quienes compartimos objetivos y queremos transformar la manera de comprender y abordar la menstruación y el ciclo vital.',
      'Porque quieres contribuir a sostener una asociación independiente y hacer posible que La Vida en Rojo continúe desarrollando sus proyectos, actividades, materiales y acciones.',
      'Porque tu experiencia, tus conocimientos y tus propuestas también pueden enriquecer el trabajo colectivo.'
    ]
  },
  {
    title: 'Para qué hacerte Amiga colaboradora',
    intro: 'Tu colaboración nos permite:',
    items: [
      'Sostener y hacer crecer el trabajo de La Vida en Rojo en educación, investigación, divulgación y acción.',
      'Generar y compartir conocimientos y recursos sobre cultura menstrual y climatérica.',
      'Impulsar actividades, proyectos y espacios de encuentro entre mujeres, profesionales, proyectos y entidades.',
      'Fortalecer una red de colaboración que amplíe el alcance de las iniciativas vinculadas a la cultura menstrual.',
      'Dar continuidad a una voz asociativa independiente, comprometida con los derechos menstruales y con una mirada feminista, interseccional y de justicia social.',
      'Construir colectivamente nuevas propuestas, acciones y formas de hacer.'
    ]
  },
  {
    title: 'Beneficios de ser Amiga colaboradora',
    items: [
      'Descuentos en eventos y formaciones organizadas por la asociación.',
      'Visibilidad para tu proyecto en nuestras redes sociales, siempre que esté alineado con los objetivos de divulgación y educación de la asociación.',
      'Participación como colaboradora en actividades, proyectos e iniciativas de la Asociación o que esta apoye.',
      'Posibilidad de contar con el respaldo de La Vida en Rojo y utilizar su logo en actividades vinculadas a la cultura menstrual, previa firma de un convenio.',
      'Formar parte del directorio de personas y proyectos vinculados a la cultura menstrual de la Asociación.',
      'Formar parte del grupo de WhatsApp de Amigas colaboradoras.',
      'Asesoramiento u orientación ante posibles dudas relacionadas con el desarrollo de tus actividades.'
    ]
  },
  {
    title: 'Compromisos de la Amiga colaboradora',
    items: [
      'Participar en las asambleas virtuales o presenciales que se realicen durante el año.',
      'Participar en las reuniones bimensuales del grupo de trabajo «Cíclica_mente reunidas».',
      'Colaborar en la difusión de las actividades, acciones y publicaciones de La Vida en Rojo en tus redes y contactos.',
      'Participar y colaborar en proyectos, actividades o eventos organizados por La Vida en Rojo o que cuenten con su apoyo.',
      'Contribuir a una cultura menstrual crítica, libre de tabúes, violencias y desinformación, y respetuosa con nuestros cuerpos y los ecosistemas.'
    ]
  }
]

const FormEmbed = ({ title, onOpen }) => (
  <button type='button' className='whydoit__button' onClick={onOpen}>
    Abrir formulario de {title}
  </button>
)

const Whydoit = () => {
  const [activeForm, setActiveForm] = useState(null)

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setActiveForm(null)
    }

    if (activeForm) {
      document.addEventListener('keydown', handleKeyDown)
    }

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [activeForm])

  const openForm = (title, src) => setActiveForm({ title, src })

  return (
    <section className='whydoit section__padding' id='red' aria-labelledby='friends-modalities-title'>
      <div className='whydoit__shell'>
        <p className='whydoit__contribution'><strong>La aportación anual para 2026-2027 es de 26 €, tanto para las personas amigas donadoras como para las colaboradoras.</strong> El pago se realiza mediante Bizum, un sistema disponible únicamente para cuentas bancarias del Estado español. Si no es tu caso, contáctanos en <a href='mailto:asociacionculturamenstrual@gmail.com'>asociacionculturamenstrual@gmail.com</a>.</p>

        <div className='whydoit__header'>
          <div id='friends-modalities-title' className='whydoit__title'>
            <SubHeading title='Modalidades de amigas' color={true} />
          </div>
          <div className='whydoit__divider' aria-hidden='true'></div>
        </div>

        <div className='whydoit__intro'>
          <p className='whydoit__lead'>
            Hay dos modalidades de persona amiga: <span className='whydoit__lead-highlight'>donadora o colaboradora</span>. Elige la que mejor encaje contigo y, estés donde estés, suma tu apoyo a La Vida en Rojo desde cualquier lugar del mundo.
          </p>
        </div>

        <div className='whydoit__collab-layout'>
          <article className='whydoit__option whydoit__option--recommended whydoit__grid-donadora'>
            <p className='whydoit__option-kicker'>COLABORACIÓN RECOMENDADA</p>
            <h2 className='whydoit__option-title'>Amiga donadora</h2>
            <p className='whydoit__paragraph'>Si tus circunstancias no te permiten implicarte de manera activa, puedes colaborar con la asociación mediante una donación anual. Tu aporte sostiene procesos de divulgación, acompañamiento y acción comunitaria, y fortalece la Cultura Menstrual en todo el territorio.</p>
            <FormEmbed title='Amiga donadora' onOpen={() => openForm('Amiga donadora', 'https://my.liberaforms.org/embed/amigas-donadoras-2026-2027')} />
          </article>

          <article className='whydoit__option whydoit__option--colaboradora whydoit__grid-colaboradora' aria-labelledby='collaborator-option-title'>
            <h2 id='collaborator-option-title' className='whydoit__option-title'>Amiga colaboradora</h2>
            <p className='whydoit__paragraph'>Participa activamente en la red de colaboración de La Vida en Rojo, aportando según tus posibilidades tiempo, conocimientos y recursos, y sumándote a proyectos, actividades, investigaciones, eventos y otras acciones promovidas por la asociación. Para unirte, solo hay que completar el formulario tanto si es tu primer año como si repites.</p>
            <details className='whydoit__overview'>
              <summary className='whydoit__overview-trigger'>Todo lo que necesitas saber</summary>
              <div className='whydoit__overview-content'>
                <div className='whydoit__accordions'>
                  {collaboratorCards.map((card) => (
                    <details key={card.title} className='whydoit__accordion'>
                      <summary className='whydoit__accordion-title'>{card.title}</summary>
                      <div className='whydoit__accordion-content'>
                        {card.intro && <p className='whydoit__card-copy'>{card.intro}</p>}
                        <ul className='whydoit__list'>
                          {card.items.map((item) => <li key={item} className='whydoit__list-item'>{item}</li>)}
                        </ul>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </details>
            <FormEmbed title='Amiga colaboradora' onOpen={() => openForm('Amiga colaboradora', 'https://my.liberaforms.org/embed/amigas-colaboradoras-2026-2027')} />
          </article>

          <article className='whydoit__option whydoit__grid-entidades'>
            <h2 className='whydoit__option-title'>Entidades amigas</h2>
            <p className='whydoit__paragraph'>Las entidades amigas son aquellas personas jurídicas (asociaciones de mujeres, grupos de mujeres o fundaciones) que contribuyen a sostener y hacer crecer La Vida en Rojo. Para poder ser entidad amiga, al menos una de sus integrantes debe tener la condición de Amiga colaboradora, quien actuará como representante de la entidad.</p>
            <FormEmbed title='Amiga colaboradora' onOpen={() => openForm('Entidades Amigas', 'https://my.liberaforms.org/embed/amigas-colaboradoras-2026-2027')} />
          </article>
        </div>
      </div>

      {activeForm && (
        <div
          className='whydoit__modal-overlay'
          role='presentation'
          onClick={(event) => {
            if (event.target === event.currentTarget) setActiveForm(null)
          }}
        >
          <div className='whydoit__modal' role='dialog' aria-modal='true' aria-labelledby='whydoit-modal-title'>
            <button type='button' className='whydoit__modal-close' onClick={() => setActiveForm(null)} aria-label='Cerrar formulario'>
              ×
            </button>
            <h2 id='whydoit-modal-title'>Formulario de {activeForm.title}</h2>
            <iframe
              className='whydoit__form'
              title={`Formulario de ${activeForm.title}`}
              width='500'
              height='600'
              frameBorder='0'
              src={activeForm.src}
            />
          </div>
        </div>
      )}
    </section>
  )
}

export default Whydoit
